// A grid shape's picture on the Shape row (item 13's mockup): its grids as squares, each outline
// drawn over all the fills so the shared boxes show. Drawn as of 9×9 grids, whatever size is
// picked, so the pictures stay put.
import { shapeLayout, type ShapeKey } from '@zinc/shared';

export function ShapeIcon({ shape }: { shape: ShapeKey | null }) {
  const layout = shape ? shapeLayout(shape, 9) : null;
  const side = layout ? Math.max(layout.rows, layout.cols) : 21;
  const corners: [number, number][] = layout?.corners ?? [[6, 6]];
  const width = side / 23;
  return (
    <svg width="40" height="40" viewBox={`0 0 ${side} ${side}`} aria-hidden="true">
      {corners.map(([r, c], i) => (
        <rect key={`f${i}`} x={c} y={r} width={9} height={9} className="fill-surface" />
      ))}
      {corners.map(([r, c], i) => (
        <rect
          key={`s${i}`}
          x={c}
          y={r}
          width={9}
          height={9}
          fill="none"
          stroke="currentColor"
          strokeWidth={width}
        />
      ))}
    </svg>
  );
}
